import ApiService from '@/api/ApiService'
import proxy from '@/shared/proxy'
import store from '@/store/store'
import { PhoneNumber } from 'google-libphonenumber'

const SupportService = {

  GetSupportTopics (context: string) {
    return ApiService.getAsync(proxy.Supportv1, `/Support/B2CTicket/TopicsByContext?context=${context}`)
  },
  PostBTCTicket (topic: string, context: string, subContext: string, description: string, image?: any, additionalInfo?: any) {
    return ApiService.postAsyncTicket(proxy.Supportv1, '/Support/B2CTicket/Create', {
      Topic: topic,
      Context: context,
      SubContext: subContext,
      Description: description,
      Image: image,
      AdditionalInfo: additionalInfo,
      DeviceID: 'NoDeviceIdAvailable'
    })
  },
  PutBTCTicket (ticketId: string, topic: string, context: string, subContext: string, description: string, image?: string, additionalInfo?: any) {
    return ApiService.postAsync(proxy.Supportv1, `/Support/B2CTicket/UpdateB2CTicket/${ticketId}`, {
      Topic: topic,
      Context: context,
      SubContext: subContext,
      Description: description,
      Image: image,
      AdditionalInfo: additionalInfo
    })
  },
  GetUserBTCTicket () {
    return ApiService.getAsync(proxy.Supportv1, '/Support/B2CTicket/UserTickets')
  }
}
export default SupportService
